import { gql } from "@apollo/client";

const GET_COURSES = gql`
  query GetCourses($levelId: ID!, $courseType: String!, $courseDays: String!) {
    courses(
      levelId: $levelId
      courseType: $courseType
      courseDays: $courseDays
    ) {
      id
      description
      level {
        title
      }
      courseType
      courseDays
      future
      ongoing
    }
  }
`;

export default GET_COURSES;
